import { tokens } from "@/tokens";
import { FC, ReactElement, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { SETTINGS_MENU } from "@/roles/sidebar-items";
import { useAppSelector } from "@/store";
import { roles } from "@/roles";

const Settings: FC = (): ReactElement => {
  const { user } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();

  const isTDAdmin = user?.userRole === roles.TDADMIN;

  const visibleMenuItems = useMemo(
    () => SETTINGS_MENU.filter((item) => !item.adminOnly || isTDAdmin),
    [isTDAdmin]
  );

  const currentTab = useMemo(() => {
    const path = location.pathname.split("/").pop() || "";
    const idx = visibleMenuItems.findIndex((item) => item.link === path);
    return idx >= 0 ? idx : 0;
  }, [location.pathname, visibleMenuItems]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    const item = visibleMenuItems[newValue];
    if (item) {
      navigate(`/settings/${item.link}`);
    }
  };

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", py: 1.5 }}>
      <Box
        sx={{
          border: `1px solid ${tokens.border.default}`,
          borderRadius: tokens.radius.lg,
          bgcolor: tokens.bg.surface,
        }}
      >
        {visibleMenuItems.length > 1 && (
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            sx={{
              borderBottom: `1px solid ${tokens.border.light}`,
              px: 2,
              minHeight: 40,
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: tokens.fontSize.sm2,
                fontWeight: tokens.fontWeight.semibold,
                minHeight: 40,
                py: 0,
              },
            }}
          >
            {visibleMenuItems.map((item) => (
              <Tab key={item.link} label={item.title} />
            ))}
          </Tabs>
        )}
        <Outlet />
      </Box>
    </Box>
  );
};

export default Settings;
